import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=0fd4137c&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=0fd4137c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4137c",
  null
  
)

export default component.exports